import { Image, Props as ImageProps } from '@ui/Image';

import qrFooter from './images/footer.png';
import qrMainPageBanner from './images/main-page-banner.png';
import qrCategoryPageBanner from './images/category-page-banner.png';
import qrProfilePageBanner from './images/profile-page-banner.png';
import qrFavoriteActionBanner from './images/favorite-action-banner.png';
import qrSellerActionBanner from './images/seller-action-banner.png';
import qrBrandActionBanner from './images/brand-action-banner.png';
import qrProductAddedPage from './images/product-added-page.png';
import qrOrderCreatedPage from './images/order-created-page.png';
import qrDialogCreatedPage from './images/dialog-created-page.png';
import qrFirstMessageBuyer from './images/first-message-buyer.png';
import qrFirstMessageSeller from './images/first-message-seller.png';
import qrFirstOrderMessageBuyer from './images/first-order-message-buyer.png';
import qrFirstOrderMessageSeller from './images/first-order-message-seller.png';

export enum QRCodePlacement {
  Footer,
  MainPageBanner,
  CategoryPageBanner,
  ProfilePageBanner,
  FavoriteActionBanner,
  SellerActionBanner,
  BrandActionBanner,
  ProductAddedPage,
  OrderCreatedPage,
  DialogCreatedPage,
  FirstMessageBuyer,
  FirstMessageSeller,
  FirstOrderMessageBuyer,
  FirstOrderMessageSeller,
}

const QR_CODE_MAP = {
  [QRCodePlacement.Footer]: qrFooter,
  [QRCodePlacement.MainPageBanner]: qrMainPageBanner,
  [QRCodePlacement.CategoryPageBanner]: qrCategoryPageBanner,
  [QRCodePlacement.ProfilePageBanner]: qrProfilePageBanner,
  [QRCodePlacement.FavoriteActionBanner]: qrFavoriteActionBanner,
  [QRCodePlacement.SellerActionBanner]: qrSellerActionBanner,
  [QRCodePlacement.BrandActionBanner]: qrBrandActionBanner,
  [QRCodePlacement.ProductAddedPage]: qrProductAddedPage,
  [QRCodePlacement.OrderCreatedPage]: qrOrderCreatedPage,
  [QRCodePlacement.DialogCreatedPage]: qrDialogCreatedPage,
  [QRCodePlacement.FirstMessageBuyer]: qrFirstMessageBuyer,
  [QRCodePlacement.FirstMessageSeller]: qrFirstMessageSeller,
  [QRCodePlacement.FirstOrderMessageBuyer]: qrFirstOrderMessageBuyer,
  [QRCodePlacement.FirstOrderMessageSeller]: qrFirstOrderMessageSeller,
};

interface Props extends Omit<ImageProps, 'src'> {
  placement: QRCodePlacement,
}

export const AppsPromotionQRCode: React.FC<Props> = ({
  placement,
  ...props
}) => {
  const src = QR_CODE_MAP[placement];

  return (
    <Image
      src={src}
      {...props}
    />
  );
};
